/* ══════════════════════════════════════════════════════════════════════
   Skön Cosmetics — skon-quiz-routines.js
   asset: assets/skon-quiz-routines.js
   Aggiornato: 28 aprile 2026 (prima release nuovi contenuti routines)
   Versione: 2.0

   Strutture dati del nuovo modello diagnostico:
   - Indici risposta → chiave lookup
   - Lookup table 5×5×5 (125 combinazioni → 28 routine)
   - 28 routine con core (4 ID) + tips (3 ID)

   FONTE DI VERITÀ: Sko_n_Skin_Test_V3.xlsx — fogli Combinazioni e Routine
   DEPLOYMENT: caricare DOPO skon-quiz-priority.js e PRIMA di skon-quiz.js
══════════════════════════════════════════════════════════════════════ */

/* ── INDICI RISPOSTA → CHIAVE NUMERICA LOOKUP ───────────────────────── */

var AGE_INDEX = {
  'lt25':   1,
  '25-35':  2,
  '35-45':  3,
  '45-55':  4,
  '55plus': 5,
};

var SKIN_INDEX = {
  'normale':        6,
  'disidratata':    7,
  'secca_sensibile':8,
  'mista_grassa':   9,
  'stanca_segnata': 10,
};

var DESIRE_INDEX = {
  'levigata_rimpolpata': 11,
  'forte_morbida':       12,
  'libera_imperfezioni': 13,
  'tonica_elastica':     14,
  'uniforme_luminosa':   15,
};

/* ── LOOKUP TABLE 5×5×5 = 125 COMBINAZIONI ─────────────────────────── */
// Fonte: foglio "Combinazioni" — Excel Sko_n_Skin_Test_V3.xlsx
// Struttura: LOOKUP[age_idx][skin_idx][desire_idx] = 'CODICE_ROUTINE'

var LOOKUP = {
  /* ── ETÀ 1: <25 ──────────────────────────────────────────── */
  1: {
    6:  { 11: 'A1', 12: 'B1', 13: 'C1', 14: 'A1', 15: 'D1' },  // normale
    7:  { 11: 'A3', 12: 'B1', 13: 'C3', 14: 'A3', 15: 'D3' },  // disidratata
    8:  { 11: 'A3', 12: 'B1', 13: 'C3', 14: 'A3', 15: 'D3' },  // secca/sensibile
    9:  { 11: 'A5', 12: 'B3', 13: 'C5', 14: 'A5', 15: 'D5' },  // mista/grassa
    10: { 11: 'A1', 12: 'B1', 13: 'C1', 14: 'A1', 15: 'D1' },  // stanca/segnata
  },
  /* ── ETÀ 2: 25-35 ────────────────────────────────────────── */
  2: {
    6:  { 11: 'A1', 12: 'B1', 13: 'C1', 14: 'A1', 15: 'D1' },
    7:  { 11: 'A3', 12: 'B1', 13: 'C3', 14: 'A3', 15: 'D3' },
    8:  { 11: 'A3', 12: 'B1', 13: 'C3', 14: 'A3', 15: 'D3' },
    9:  { 11: 'A5', 12: 'B3', 13: 'C5', 14: 'A5', 15: 'D5' },
    10: { 11: 'A1', 12: 'B1', 13: 'C1', 14: 'A1', 15: 'D1' },
  },
  /* ── ETÀ 3: 35-45 ────────────────────────────────────────── */
  3: {
    6:  { 11: 'A2', 12: 'B2', 13: 'C2', 14: 'A2', 15: 'D2' },
    7:  { 11: 'A4', 12: 'B2', 13: 'C4', 14: 'A4', 15: 'D4' },
    8:  { 11: 'A4', 12: 'B2', 13: 'C4', 14: 'A4', 15: 'D4' },
    9:  { 11: 'A6', 12: 'B4', 13: 'C6', 14: 'A6', 15: 'D6' },
    10: { 11: 'A2', 12: 'B2', 13: 'C2', 14: 'A2', 15: 'D2' },
  },
  /* ── ETÀ 4: 45-55 ────────────────────────────────────────── */
  4: {
    6:  { 11: 'A2', 12: 'B2', 13: 'C2', 14: 'A2', 15: 'D2' },
    7:  { 11: 'A4', 12: 'B2', 13: 'C4', 14: 'A4', 15: 'D4' },
    8:  { 11: 'A4', 12: 'B2', 13: 'C4', 14: 'A4', 15: 'D4' },
    9:  { 11: 'A6', 12: 'B4', 13: 'C6', 14: 'A6', 15: 'D6' },
    10: { 11: 'A2', 12: 'B2', 13: 'C2', 14: 'A2', 15: 'D2' },
  },
  /* ── ETÀ 5: 55+ ──────────────────────────────────────────── */
  5: {
    6:  { 11: 'A7', 12: 'A8', 13: 'C2', 14: 'A7', 15: 'D7' },
    7:  { 11: 'A8', 12: 'A8', 13: 'C4', 14: 'A8', 15: 'D8' },
    8:  { 11: 'A8', 12: 'A8', 13: 'C4', 14: 'A8', 15: 'D8' },
    9:  { 11: 'A9', 12: 'A9', 13: 'C6', 14: 'A9', 15: 'D9' },
    10: { 11: 'A7', 12: 'A8', 13: 'C2', 14: 'A7', 15: 'D7' },
  },
};

/* ── 28 ROUTINE ─────────────────────────────────────────────────────── */
// Fonte: foglio "Routine" — Excel Sko_n_Skin_Test_V3.xlsx
// core: 4 ID prodotto (fissi, diagnostici)
// tips: 3 ID prodotto (default — modulabili via SKON_PRIORITY)
// profileLetter: A = pro-aging | B = idratazione | C = imperfezioni | D = luminosità

var ROUTINES = {};

/* ── PROFILO A — Pro-aging ──────────────────────────────────────────── */
ROUTINES['A1'] = {
  title:         'Per una pelle bella, sana e luminosa',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle bella, sana e luminosa ✨ #TurnYourSkinÖn',
  profileLetter: 'A',
  core: ['cmu_mousse', 'better_late', 'forever_young_cream', 'fy_eye_cream'],
  tips: ['cmu_balm', 'cmu_essence', 'ak_glow'],
};

ROUTINES['A2'] = {
  title:         'Per una pelle bella, sana e luminosa',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle bella, sana e luminosa ✨ #TurnYourSkinÖn',
  profileLetter: 'A',
  core: ['cmu_mousse', 'better_late', 'forever_young_cream', 'fy_eye_cream'],
  tips: ['cmu_balm', 'ak_glow', 'booster_collagene'],
};

ROUTINES['A3'] = {
  title:         'Per una pelle bella, sana e luminosa',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle bella, sana e luminosa ✨ #TurnYourSkinÖn',
  profileLetter: 'A',
  core: ['cmu_gel', 'arctic_waterfalls', 'forever_young_cream', 'fy_eye_cream'],
  tips: ['cmu_oil', 'cmu_essence', 'ak_glow'],
};

ROUTINES['A4'] = {
  title:         'Per una pelle bella, sana e luminosa',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle bella, sana e luminosa ✨ #TurnYourSkinÖn',
  profileLetter: 'A',
  core: ['cmu_gel', 'arctic_waterfalls', 'forever_young_cream', 'fy_eye_cream'],
  tips: ['cmu_oil', 'ak_glow', 'booster_collagene'],
};

ROUTINES['A5'] = {
  title:         'Per una pelle bella, sana e luminosa',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle bella, sana e luminosa ✨ #TurnYourSkinÖn',
  profileLetter: 'A',
  core: ['imperfect_gel_cleanser', 'better_late', 'forever_young_cream', 'fy_eye_cream'],
  tips: ['cmu_oil', 'imperfect_exfol', 'ak_matt'],
};

ROUTINES['A6'] = {
  title:         'Per una pelle bella, sana e luminosa',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle bella, sana e luminosa ✨ #TurnYourSkinÖn',
  profileLetter: 'A',
  core: ['imperfect_gel_cleanser', 'better_late', 'forever_young_cream', 'fy_eye_cream'],
  tips: ['cmu_oil', 'ak_matt', 'booster_collagene'],
};

ROUTINES['A7'] = {
  title:         'Per una pelle bella, sana e luminosa',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle bella, sana e luminosa ✨ #TurnYourSkinÖn',
  profileLetter: 'A',
  core: ['cmu_mousse', 'bakuplex_serum', 'bakuplex_crema_viso', 'fy_eye_cream'],
  tips: ['cmu_balm', 'ak_glow', 'booster_collagene'],
};

ROUTINES['A8'] = {
  title:         'Per una pelle bella, sana e luminosa',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle bella, sana e luminosa ✨ #TurnYourSkinÖn',
  profileLetter: 'A',
  core: ['cmu_gel', 'bakuplex_serum', 'bakuplex_crema_viso', 'fy_eye_cream'],
  tips: ['cmu_oil', 'ak_glow', 'booster_collagene'],
};

ROUTINES['A9'] = {
  title:         'Per una pelle bella, sana e luminosa',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle bella, sana e luminosa ✨ #TurnYourSkinÖn',
  profileLetter: 'A',
  core: ['imperfect_gel_cleanser', 'bakuplex_serum', 'forever_young_cream', 'fy_eye_cream'],
  tips: ['cmu_oil', 'ak_matt', 'booster_collagene'],
};

/* ── PROFILO B — Idratazione / Stay Soft ────────────────────────────── */
ROUTINES['B1'] = {
  title:         'Per una pelle forte, morbida e idratata',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle forte, morbida e idratata ✨ #TurnYourSkinÖn',
  profileLetter: 'B',
  core: ['cmu_gel', 'arctic_waterfalls', 'staysoft_cream', 'staysoft_eye'],
  tips: ['cmu_oil', 'cmu_essence', 'ak_glow'],
};

ROUTINES['B2'] = {
  title:         'Per una pelle forte, morbida e idratata',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle forte, morbida e idratata ✨ #TurnYourSkinÖn',
  profileLetter: 'B',
  core: ['cmu_gel', 'arctic_waterfalls', 'staysoft_cream', 'fy_eye_cream'],
  tips: ['cmu_oil', 'ak_glow', 'booster_collagene'],
};

ROUTINES['B3'] = {
  title:         'Per una pelle forte, morbida e idratata',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle forte, morbida e idratata ✨ #TurnYourSkinÖn',
  profileLetter: 'B',
  core: ['imperfect_gel_cleanser', 'arctic_waterfalls', 'imperfect_cream', 'staysoft_eye'],
  tips: ['cmu_oil', 'imperfect_exfol', 'ak_matt'],
};

ROUTINES['B4'] = {
  title:         'Per una pelle forte, morbida e idratata',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle forte, morbida e idratata ✨ #TurnYourSkinÖn',
  profileLetter: 'B',
  core: ['imperfect_gel_cleanser', 'arctic_waterfalls', 'imperfect_cream', 'fy_eye_cream'],
  tips: ['cmu_oil', 'ak_matt', 'booster_collagene'],
};

/* ── PROFILO C — Imperfezioni ───────────────────────────────────────── */
ROUTINES['C1'] = {
  title:         'Per una pelle sana, uniforme e libera da imperfezioni',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle sana, uniforme e libera dalle imperfezioni ✨ #TurnYourSkinÖn',
  profileLetter: 'C',
  core: ['imperfect_gel_cleanser', 'siero_imperfezioni', 'imperfect_cream', 'staysoft_eye'],
  tips: ['cmu_balm', 'imperfect_exfol', 'ak_matt'],
};

ROUTINES['C2'] = {
  title:         'Per una pelle sana, uniforme e libera da imperfezioni',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle sana, uniforme e libera dalle imperfezioni ✨ #TurnYourSkinÖn',
  profileLetter: 'C',
  core: ['imperfect_gel_cleanser', 'siero_imperfezioni', 'imperfect_cream', 'fy_eye_cream'],
  tips: ['cmu_balm', 'ak_matt', 'booster_collagene'],
};

ROUTINES['C3'] = {
  title:         'Per una pelle sana, uniforme e libera da imperfezioni',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle sana, uniforme e libera dalle imperfezioni ✨ #TurnYourSkinÖn',
  profileLetter: 'C',
  core: ['imperfect_gel_cleanser', 'arctic_waterfalls', 'imperfect_cream', 'staysoft_eye'],
  tips: ['cmu_oil', 'imperfect_exfol', 'ak_matt'],
};

ROUTINES['C4'] = {
  title:         'Per una pelle sana, uniforme e libera da imperfezioni',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle sana, uniforme e libera dalle imperfezioni ✨ #TurnYourSkinÖn',
  profileLetter: 'C',
  core: ['imperfect_gel_cleanser', 'arctic_waterfalls', 'imperfect_cream', 'fy_eye_cream'],
  tips: ['cmu_oil', 'ak_matt', 'booster_collagene'],
};

ROUTINES['C5'] = {
  title:         'Per una pelle sana, uniforme e libera da imperfezioni',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle sana, uniforme e libera dalle imperfezioni ✨ #TurnYourSkinÖn',
  profileLetter: 'C',
  core: ['imperfect_gel_cleanser', 'siero_imperfezioni', 'imperfect_cream', 'staysoft_eye'],
  tips: ['cmu_oil', 'imperfect_exfol', 'ak_matt'],
};

ROUTINES['C6'] = {
  title:         'Per una pelle sana, uniforme e libera da imperfezioni',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle sana, uniforme e libera dalle imperfezioni ✨ #TurnYourSkinÖn',
  profileLetter: 'C',
  core: ['imperfect_gel_cleanser', 'siero_imperfezioni', 'imperfect_cream', 'fy_eye_cream'],
  tips: ['cmu_oil', 'ak_matt', 'booster_collagene'],
};

/* ── PROFILO D — Luminosità / Macchie ───────────────────────────────── */
ROUTINES['D1'] = {
  title:         'Per una pelle uniforme e luminosa',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle uniforme e luminosa ✨ #TurnYourSkinÖn',
  profileLetter: 'D',
  core: ['cmu_mousse', 'vitamin_blast', 'over_the_moon', 'staysoft_eye'],
  tips: ['cmu_balm', 'imperfect_exfol', 'ak_glow'],
};

ROUTINES['D2'] = {
  title:         'Per una pelle uniforme e luminosa',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle uniforme e luminosa ✨ #TurnYourSkinÖn',
  profileLetter: 'D',
  core: ['cmu_mousse', 'vitamin_blast', 'over_the_moon', 'fy_eye_cream'],
  tips: ['cmu_balm', 'ak_glow', 'booster_collagene'],
};

ROUTINES['D3'] = {
  title:         'Per una pelle uniforme e luminosa',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle uniforme e luminosa ✨ #TurnYourSkinÖn',
  profileLetter: 'D',
  core: ['cmu_gel', 'vitamin_blast', 'over_the_moon', 'staysoft_eye'],
  tips: ['cmu_oil', 'arctic_waterfalls', 'ak_glow'],
};

ROUTINES['D4'] = {
  title:         'Per una pelle uniforme e luminosa',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle uniforme e luminosa ✨ #TurnYourSkinÖn',
  profileLetter: 'D',
  core: ['cmu_gel', 'vitamin_blast', 'over_the_moon', 'fy_eye_cream'],
  tips: ['cmu_oil', 'ak_glow', 'booster_collagene'],
};

ROUTINES['D5'] = {
  title:         'Per una pelle uniforme e luminosa',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle uniforme e luminosa ✨ #TurnYourSkinÖn',
  profileLetter: 'D',
  core: ['imperfect_gel_cleanser', 'vitamin_blast', 'over_the_moon', 'staysoft_eye'],
  tips: ['cmu_oil', 'imperfect_exfol', 'ak_matt'],
};

ROUTINES['D6'] = {
  title:         'Per una pelle uniforme e luminosa',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle uniforme e luminosa ✨ #TurnYourSkinÖn',
  profileLetter: 'D',
  core: ['imperfect_gel_cleanser', 'vitamin_blast', 'over_the_moon', 'fy_eye_cream'],
  tips: ['cmu_oil', 'imperfect_exfol', 'ak_matt'],
};

ROUTINES['D7'] = {
  title:         'Per una pelle uniforme e luminosa',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle uniforme e luminosa ✨ #TurnYourSkinÖn',
  profileLetter: 'D',
  core: ['cmu_mousse', 'vitamin_blast', 'over_the_moon', 'fy_eye_cream'],
  tips: ['bakuplex_serum', 'ak_glow', 'booster_collagene'],
};

ROUTINES['D8'] = {
  title:         'Per una pelle uniforme e luminosa',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle uniforme e luminosa ✨ #TurnYourSkinÖn',
  profileLetter: 'D',
  core: ['cmu_gel', 'vitamin_blast', 'over_the_moon', 'fy_eye_cream'],
  tips: ['bakuplex_serum', 'ak_glow', 'booster_collagene'],
};

ROUTINES['D9'] = {
  title:         'Per una pelle uniforme e luminosa',
  intro:         'Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle uniforme e luminosa ✨ #TurnYourSkinÖn',
  profileLetter: 'D',
  core: ['imperfect_gel_cleanser', 'vitamin_blast', 'over_the_moon', 'fy_eye_cream'],
  tips: ['bakuplex_serum', 'ak_matt', 'booster_collagene'],
};

/* ══════════════════════════════════════════════════════════════════════
   VALIDAZIONE SELF-CHECK (solo in sviluppo — rimossa in produzione
   oppure lasciata: ha costo zero a runtime dopo il caricamento)
══════════════════════════════════════════════════════════════════════ */
(function _validateRoutines() {
  var CATALOG_IDS = [
    'cmu_mousse','cmu_gel','cmu_balm','cmu_oil','cmu_essence',
    'imperfect_gel_cleanser','imperfect_exfol','imperfect_cream',
    'arctic_waterfalls','better_late','bakuplex_serum','siero_imperfezioni',
    'fy_eye_cream','staysoft_eye',
    'forever_young_cream','staysoft_cream','vitamin_blast','over_the_moon','bakuplex_crema_viso',
    'ak_glow','ak_matt',
    'booster_collagene',
  ];
  var catalogSet = {};
  CATALOG_IDS.forEach(function(id) { catalogSet[id] = true; });

  var allRoutineIds = {};
  Object.keys(ROUTINES).forEach(function(code) {
    var r = ROUTINES[code];
    r.core.concat(r.tips).forEach(function(id) { allRoutineIds[id] = true; });
  });

  var missing = Object.keys(allRoutineIds).filter(function(id) { return !catalogSet[id]; });
  if (missing.length > 0) {
    console.error('[skon-quiz-routines] ⚠️ ID prodotto non nel CATALOG:', missing.join(', '));
  }

  var routineCount = Object.keys(ROUTINES).length;
  if (routineCount !== 28) {
    console.error('[skon-quiz-routines] ⚠️ Numero routine atteso 28, trovato:', routineCount);
  }

  var lookupCount = 0;
  for (var a in LOOKUP) {
    for (var s in LOOKUP[a]) {
      for (var d in LOOKUP[a][s]) {
        lookupCount++;
        var code = LOOKUP[a][s][d];
        if (!ROUTINES[code]) {
          console.error('[skon-quiz-routines] ⚠️ Lookup punta a routine inesistente:', code, 'a=' + a, 's=' + s, 'd=' + d);
        }
      }
    }
  }
  if (lookupCount !== 125) {
    console.error('[skon-quiz-routines] ⚠️ Entry lookup attese 125, trovate:', lookupCount);
  }
}());